import { FormField } from './form-field';

export class FormFieldDropdown extends FormField<string> {
  controlType = 'dropdown';
  options: {key: string, value: string, selected: boolean, disabled: boolean}[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}
